import React, { useState } from 'react';
import { Box, CssBaseline, Drawer, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SuperAdminSidebar from '../components/SuperAdminSidebar';
import SuperAdminHeader from '../components/SuperAdminHeader';

function SuperAdminLayout({ children }) {
  const [open, setOpen] = useState(true);
  const drawerWidth = open ? 240 : 60;
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <CssBaseline />
      <Drawer
        variant={window.innerWidth < 900 ? 'temporary' : 'permanent'}
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          zIndex: 1200,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            transition: 'width 0.3s',
            overflowX: 'hidden',
            zIndex: 1200,
          },
        }}
      >
        <SuperAdminSidebar mini={!open} />
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: { xs: 1, md: 3 }, transition: 'margin 0.3s', ml: { xs: 0, md: `${drawerWidth}px` } }}>
        <IconButton onClick={() => setOpen(!open)} sx={{ mb: 2, position: 'fixed', top: 16, left: open ? drawerWidth + 16 : 16, zIndex: 1300 }}>
          <MenuIcon />
        </IconButton>
        <SuperAdminHeader />
        <Box sx={{ mt: 4 }}>{children}</Box>
      </Box>
    </Box>
  );
}

export default SuperAdminLayout;
